import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Inicio from '@/components/Inicio'

import AdelantosNominaAdministrativo from '@/components/adelantos/AdelantosNominaAdministrativo'
import AdelantosNominaSupervisor from '@/components/adelantos/AdelantosNominaSupervisor'
import AdelantosNominaValidar from '@/components/adelantos/AdelantosNominaValidar'

import AsistenciasPuntos from '@/components/asistencias/AsistenciasPuntos'
import AsistenciasPuntoSeleccionado from '@/components/asistencias/AsistenciasPuntoSeleccionado'
import AsistenciasTiemposExtra from '@/components/asistencias/AsistenciasTiemposExtra'
import AsistenciasValidarTiemposExtra from '@/components/asistencias/AsistenciasValidarTiemposExtra'

import ClientesListado from '@/components/clientes/ClientesListado'
import ClientesNuevo from '@/components/clientes/ClientesNuevo'
import ClientesEditar from '@/components/clientes/ClientesEditar'

import ConceptosListado from '@/components/conceptos/ConceptosListado'
import ConceptosNuevo from '@/components/conceptos/ConceptosNuevo'
import ConceptosEditar from '@/components/conceptos/ConceptosEditar'

import ContratosListado from '@/components/contratos/ContratosListado'
import ContratosNuevo from '@/components/contratos/ContratosNuevo'
import ContratosEditar from '@/components/contratos/ContratosEditar'

import EmpleadosListado from '@/components/empleados/EmpleadosListado'
import EmpleadosNuevo from '@/components/empleados/EmpleadosNuevo'
import EmpleadosEditar from '@/components/empleados/EmpleadosEditar'
import EmpleadosDetalle from '@/components/empleados/EmpleadosDetalle'

import IncidenciasListado from '@/components/incidencias/IncidenciasListado'
import IncidenciasAtendidasListado from '@/components/incidencias/IncidenciasAtendidasListado'
import IncidenciasPendientesListado from '@/components/incidencias/IncidenciasPendientesListado'
import IncidenciasNueva from '@/components/incidencias/IncidenciasNueva'

import NominaResumen from '@/components/nomina/NominaResumen'
import NominaDiasFestivos from '@/components/nomina/NominaDiasFestivos'

import PlanesListado from '@/components/planes/PlanesListado'
import PlanesNuevo from '@/components/planes/PlanesNuevo'
import PlanesEditar from '@/components/planes/PlanesEditar'
import PlanesDetalle from '@/components/planes/PlanesDetalle'

import PuestosListado from '@/components/puestos/PuestosListado'
import PuestosNuevo from '@/components/puestos/PuestosNuevo'

import PuntosListado from '@/components/puntos/PuntosListado'
import PuntosSeleccionarCliente from '@/components/puntos/PuntosSeleccionarCliente'
import PuntosNuevo from '@/components/puntos/PuntosNuevo'
import PuntosEditar from '@/components/puntos/PuntosEditar'
import PuntosDetalle from '@/components/puntos/PuntosDetalle'
import PuntosRoles from '@/components/puntos/PuntosRoles'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Inicio',
    component: Inicio
  },
  {
    path: '/inicio',
    name: 'Inicio2',
    component: Inicio
  },
  //Adelantos de nomina
  {
    path: '/adelantos/',
    name: 'AdelantosNominaAdministrativo',
    component: AdelantosNominaAdministrativo
  },
  {
    path: '/adelantos-nomina',
    name: 'AdelantosNominaSupervisor',
    component: AdelantosNominaSupervisor
  },
  {
    path: '/validar-adelantos/',
    name: 'AdelantosNominaValidar',
    component: AdelantosNominaValidar
  },
  //Asistencias y pases de lista
  {
    path: '/asistencias',
    name: 'AsistenciasPuntos',
    component: AsistenciasPuntos
  },
  {
    path: '/asistencia/:turno',
    name: 'AsistenciasPuntoSeleccionado',
    component: AsistenciasPuntoSeleccionado
  },
  {
    path: '/tiemposextra/asignar',
    name: 'AsistenciasTiemposExtra',
    component: AsistenciasTiemposExtra
  },
  {
    path: '/tiemposextra/validar',
    name: 'AsistenciasValidarTiemposExtra',
    component: AsistenciasValidarTiemposExtra
  },
  //Clientes
  {
    path: '/clientes',
    name: 'ClientesListado',
    component: ClientesListado
  },
  {
    path: '/cliente',
    name: 'ClientesNuevo',
    component: ClientesNuevo
  },
  {
    path: '/cliente/:cliente/editar',
    name: 'ClientesEditar',
    component: ClientesEditar
  },
  //Conceptos
  {
    path: '/conceptos',
    name: 'ConceptosListado',
    component: ConceptosListado
  },
  {
    path: '/concepto',
    name: 'ConceptosNuevo',
    component: ConceptosNuevo
  },
  {
    path: '/concepto/:concepto/editar',
    name: 'ConceptosEditar',
    component: ConceptosEditar
  },
  //Contratos laborales de guardias, prestación de servicios de monitoreo y alarmas y contrato de prestación de servicios de guardias de seguridad
  {
    path: '/contratos',
    name: 'ContratosListado',
    component: ContratosListado
  },
  {
    path: '/contrato/nuevo',
    name: 'ContratosNuevo',
    component: ContratosNuevo
  },
  {
    path: '/contrato/:contrato/editar',
    name: 'ContratosEditar',
    component: ContratosEditar
  },
  //Empleados
  {
    path: '/empleados',
    name: 'EmpleadosListado',
    component: EmpleadosListado
  },
  {
    path: '/empleado/nuevo',
    name: 'EmpleadosNuevo',
    component: EmpleadosNuevo
  },
  {
    path: '/empleado/:empleado/editar',
    name: 'EmpleadosEditar',
    component: EmpleadosEditar
  },
  {
    path: '/empleado/:empleado/detalle',
    name: 'EmpleadosDetalle',
    component: EmpleadosDetalle
  },
  //Incidencias
  {
    path: '/incidencias',
    name: 'IncidenciasListado',
    component: IncidenciasListado
  },
  {
    path: '/incidencias/atendidas',
    name: 'IncidenciasAtendidasListado',
    component: IncidenciasAtendidasListado
  },
  {
    path: '/incidencias/pendientes',
    name: 'IncidenciasPendientesListado',
    component: IncidenciasPendientesListado
  },
  {
    path: '/incidencia/nueva',
    name: 'IncidenciasNueva',
    component: IncidenciasNueva
  },
  //Nomina
  {
    path: '/nomina/resumen',
    name: 'NominaResumen',
    component: NominaResumen
  },
  {
    path: '/nomina/diasfestivos',
    name: 'NominaDiasFestivos',
    component: NominaDiasFestivos
  },
  //Planes de pago
  {
    path: '/planes',
    name: 'PlanesListado',
    component: PlanesListado
  },
  {
    path: '/plan',
    name: 'PlanesNuevo',
    component: PlanesNuevo
  },
  {
    path: '/plan/:id/editar',
    name: 'PlanesEditar',
    component: PlanesEditar
  },
  {
    path: '/plan/:id/detalle',
    name: 'PlanesDetalle',
    component: PlanesEditar
  },
  //Puestos
  {
    path: '/puestos',
    name: 'PuestosListado',
    component: PuestosListado
  },
  {
    path: '/puesto',
    name: 'PuestosNuevo',
    component: PuestosNuevo
  },
  //Puntos
  {
    path: '/puntos',
    name: 'PuntosListado',
    component: PuntosListado
  },
  {
    path: '/punto/cliente',
    name: 'PuntosSeleccionarCliente',
    component: PuntosSeleccionarCliente
  },
  {
    path: '/punto/nuevo/:cliente', //Es el id del cliente
    name: 'PuntosNuevo',
    component: PuntosNuevo
  },
  {
    path: '/punto/:punto/editar',
    name: 'PuntosEditar',
    component: PuntosEditar
  },
  {
    path: '/punto/:punto/detalle',
    name: 'PuntosDetalle',
    component: PuntosDetalle
  },
  {
    path: '/punto/:turno/rol',
    name: 'PuntosRoles',
    component: PuntosRoles
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js